import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import RadioGroup from '@mui/material/RadioGroup'

import FormInput from '../inputFields/FormInput'
import { theme } from '../../themes/theme'
import { Divider, FlexColumn, FormRow } from '../styles/Containers'
import { RowFormControl, StyledFormControlLabel, StyledRadio } from '../styles/RadioGroup'
import { Subheading, ErrorText } from '../styles/Text'
import { formSection, formWording } from '../styles/FormStyleConfig'

const Red = styled.span`
  color: ${theme.colors.error};
`

function NameForm({ format = 'default', perspective = 'requestor', disabled = false }) {
  const { register, watch, formState, getValues } = useFormContext()
  const [defaultIsBusiness, setDefaultIsBusiness] = useState()

  useEffect(() => {
    const defaultVal = getValues('requestor.isBusiness') !== undefined ? getValues('requestor.isBusiness') : null
    setDefaultIsBusiness(defaultVal)
  }, [])

  const isBusiness = watch('requestor.isBusiness')

  const error = !!formState.errors.requestor?.isBusiness
  const helperText = formState.errors?.requestor?.isBusiness?.message

  const TitleComponent = formSection[format].font.formTitle
  const TextComponent = formSection[format].font.bodyText
  const basis = formSection[format].muiTextField.basis

  return (
    <FlexColumn gap={formSection[format].gap.div}>
      <TitleComponent>{formWording[perspective].possessive} Name</TitleComponent>
      {formSection[format].divider && <Divider />}
      {defaultIsBusiness !== undefined && (
        <FlexColumn gap="0">
          <RowFormControl>
            <TextComponent>
              Are {formWording[perspective].pronoun} requesting this information for a business?<Red> *</Red>
            </TextComponent>
            <RadioGroup row name="is-business-radio-group" id="isBusiness" defaultValue={defaultIsBusiness}>
              <StyledFormControlLabel
                {...register('requestor.isBusiness')}
                value={true}
                control={<StyledRadio />}
                label="Yes"
                format={format}
                disabled={disabled}
              />
              <StyledFormControlLabel
                {...register('requestor.isBusiness')}
                value={false}
                control={<StyledRadio />}
                label="No"
                format={format}
                disabled={disabled}
              />
            </RadioGroup>
          </RowFormControl>
          {error && <ErrorText role="alert">{helperText}</ErrorText>}
        </FlexColumn>
      )}
      {isBusiness && isBusiness.toString() === 'true' && (
        <FlexColumn gap={formSection[format].gap.subDiv}>
          <Subheading>Business Details</Subheading>
          <FormRow>
            <FormInput required={true} id="requestor.businessName" label="Business Name" textFieldFormat={format} basis={basis} disabled={disabled} />
          </FormRow>
        </FlexColumn>
      )}
      <FlexColumn gap={formSection[format].gap.subDiv}>
        {isBusiness && isBusiness.toString() === 'true' && <Subheading>{formWording[perspective].possessive} Details</Subheading>}
        <FormRow gap={formSection[format].gap.row}>
          <FormInput required={true} id="requestor.firstName" label="First Name" textFieldFormat={format} basis={basis} disabled={disabled} />
          <FormInput required={false} id="requestor.middleName" label="Middle Name" textFieldFormat={format} basis={basis} disabled={disabled} />
          <FormInput required={true} id="requestor.lastName" label="Last Name" textFieldFormat={format} basis={basis} disabled={disabled} />
        </FormRow>
      </FlexColumn>
    </FlexColumn>
  )
}

NameForm.propTypes = {
  format: PropTypes.oneOf(['default', 'condensed']),
  perspective: PropTypes.oneOf(['requestor', 'staff']),
  disabled: PropTypes.bool
}

export default NameForm
